import Cookies from "js-cookie";

export function newRelease(props) {
  const releaseDate = new Date ('2026-10-29 17:00:00')
  const ago = (new Date() - releaseDate) / 3600000  //hours
  if (ago > 0 && ago < 336) {
    const seen = releaseSeen(props)
    if (seen) {
      const seenAgo = (new Date() - seen) / 3600000
      return !(seenAgo > 0 && seenAgo < 336) // not seen recently
    }
    return true //new release not seen
  }
  return false  // no new release
}
const persistMe = 'news'
export function releaseShown(props) {
  const newCookie = persistMe+props.userLogin
  Cookies.set(newCookie, JSON.stringify(Date.now()), { expires: 14 })
}
function releaseSeen (props) {
  return Cookies.get(persistMe+props.userLogin)
}
